import videojs from 'video.js';
const VideoComponent = videojs.getComponent('Component');

/**
 * 切换清晰度按钮
 */
class ChangeResPanel extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        this.handleChildrensEvent();
    }

    handleChildrensEvent() {
        this.getChild('ResOptions').on('changeRes', eventObj => {
            this.getChild('CurrentResBtn').trigger(eventObj);
        });
    }

    createEl() {
        const panelContainer = super.createEl('div', {
            className: 'video-resolution-btn vjs-control',
        });

        return panelContainer;
    }
}

ChangeResPanel.prototype.options_ = {
    children: ['CurrentResBtn', 'ResOptions'],
};

videojs.registerComponent('ChangeResPanel', ChangeResPanel);

/**
 * 当前清晰度按钮
 */
class CurrentResBtn extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        this.on('changeRes', this.changeRes);
    }

    createEl() {
        return super.createEl('span', {
            className: 'video-current-resolution',
            innerText: '自动',
        });
    }

    changeRes(eventObj) {
        const { selectRes = '自动' } = eventObj;

        this.el().innerHTML = selectRes;
    }
}

videojs.registerComponent('CurrentResBtn', CurrentResBtn);

class ResOptions extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        this.on('click', this.handleChooseRate);
    }

    createEl() {
        const resList = super.createEl('ul', {
            className: 'video-resolution-list',
        });

        resList.innerHTML = `<li data-tag="gqSrc">高清</li>
                             <li data-tag="bqSrc">标清</li>
                             <li class="currentRes" data-tag="bqSrc">自动</li>`;

        return resList;
    }

    handleChooseRate(e) {
        const liList = this.el().children;

        for (const itemLi of liList) {
            itemLi.classList.remove('currentRes');
        }

        e.target.classList.add('currentRes');

        const selectRes = e.target.innerText;
        const selectResKey = e.target.getAttribute('data-tag');

        this.trigger({
            type: 'changeRes',
            selectRes,
        });

        const { options_ } = this.player_;

        if (options_[selectResKey]) {
            const originCurrentTime = this.player().currentTime();

            this.player().src(options_[selectResKey]);
            this.player().one('timeupdate', () => {
                this.player().currentTime(originCurrentTime);
            });
        }
    }
}

videojs.registerComponent('ResOptions', ResOptions);
